(function(){
    angular
        .module('appback')
        .directive('ngAcciones', accionesCont);

        accionesCont.$inject = ['socket','GenerallabService','ResultadosService','$timeout'];
        function accionesCont(socket,GenerallabService,ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/resultadopeticion/templateresultados?name=accionescontenido.twig',
		          scope: {
                  //ngModel : '=',
                  //item: '=',
                  peticionid: '=',
                  resultados: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	//console.log(scope.peticionid);
						scope.generalLab = GenerallabService;

						scope.nodeaccion = {};

		               
						scope.resetInf = function(){
							scope.nodeaccion = {
								peticion_id:scope.peticionid,
								categoria_id:"",
								descripcion:"",
								analitica_id:"",
								tipoaccion_id:"",
								subtipoaccion_id:"",
								notificar_urano:0,
								notificar_clinica:0,		
							};
			                //console.log(scope.resultados)
			                var res = false;
			                if(angular.isDefined(scope.resultados)){
								for(var cont=0;cont<scope.resultados.length && !res;cont++){
				                  if(scope.peticionid==scope.resultados[cont].id){
				                    if(scope.resultados[cont].categorias.length==1){
				                      //SELECCIONAMOS POR DEFECTO LA CATEGORIA PORQUE SOLO HAY 1
				                      scope.nodeaccion.categoria_id = scope.resultados[cont].categorias[0].id;
				                      //console.log("categoria",scope.resultados[cont].categorias[0].id);
				                    }
				                    if(scope.resultados[cont].analiticas.length==1){
				                    	//console.log(scope.nodeaccion.analitica_id);
				                      	scope.nodeaccion.analitica_id = [scope.resultados[cont].analiticas[0].analitica.id];
				                    	//console.log(scope.nodeaccion.analitica_id);
				                     	//console.log(scope.nodeaccion)
				                      //SELECCIONAMOS POR DEFECTO LA ANALITICA PORQUE SOLO HAY 1

				                    }
				                    res = true;
				                  }
				                }
				            }
						}

						scope.resetAnaliticas = function(){
							//console.log("CAMBIANDO ANALITICA",scope.eventoVar);
							//console.log("CAMBIANDO ANALITICA",scope);
							if(scope.eventoVar){
								scope.nodeaccion.analitica_id = []
							}
						}

						scope.evento = function(event){
							//console.log(event);
							//ponemos evento para cuando se clique solamente en el selector eso, así rellenamos de inicio la analitica y no ejecuta el bnng-change
							scope.eventoVar = event;
						}



						scope.select2Categorias = { 
			        		ajax: {
			                    url: "/backend/resultadopeticion/categoriasacciones",
			                    dataType: 'json',
			                    delay: 250,
			                    data: function (params) {
			                      return {
			                        q: params.term, // search term
			                        page: params.page,
			                        field: 'nombre',
			                        per_page: 20,
			                        //nodetype:'microorganismo'
			                      };
			                    },
			                    processResults: function (data, params) {
			                      params.page = params.page || 1;
			                      return {
			                        results: data.items,
			                        pagination: {
			                          more: (params.page * 1) < data.total_count
			                        }
			                      };
			                    },
			                    cache: true
			                }
			        	};

			        	scope.select2Analiticas = { 
			        		ajax: {
			                    url: "/backend/resultadopeticion/analiticasacciones",
			                    dataType: 'json',
			                    delay: 250,
			                    data: function (params) {
			                      return {
			                        q: params.term, // search term
			                        page: params.page,
			                        field: 'nombre',
			                        per_page: 20,
			                        categoria_id:scope.categoria_id
			                        //nodetype:'microorganismo'
			                      };
			                    },
			                    processResults: function (data, params) {
			                      params.page = params.page || 1;
			                      return {
			                        results: data.items,
			                        pagination: {
			                          more: (params.page * 1) < data.total_count
			                        }
			                      };
			                    },
			                    cache: true
			                }
			        	};

						scope.getTemplate = function(){

							ResultadosService.getTemplateAcciones(scope.nodeaccion.subtipoaccion_id,function(data){
								scope.nodeaccion.descripcion = data.template;
							})
						}
						scope.resetInf();
						//console.log(scope.generalLab);
						scope.loading = false;
						scope.guardarAccion = function(){
							scope.loading = true;
							scope.code = 0;
							ResultadosService.guardarAccion(scope,function(data){
								if(data.carta.length>0){
									for(var cont=0;cont<data.carta.length;cont++){
										console.log("EMIT nueva carta");
	                            		socket.emit('pizarra:nuevacarta', { carta:data.carta[cont] });
	                            	}
								}
								$timeout(function(){
									scope.generalLab.acciones = data.acciones;
									//console.log(scope.generalLab);
								})
								scope.loading = false;
								scope.code = data.code;
							})
							//console.log(scope.nodeaccion);
						}
			        });
		        }
          }
      }
})();